'use client';

import { useEffect } from 'react';
import { trackMonetateEvent } from '@JohnLewisPartnership/jlfs-ui-library/dist/utils/monetate/trackMonetateEvent';
type MonetateEventDispatcherProps = {
  eventName: string;
};

export default function MonetateEventDispatcher({
  eventName,
}: MonetateEventDispatcherProps) {
  useEffect(() => {
    trackMonetateEvent(eventName);
  }, [eventName]);

  return null;
}
